module.exports = __webpack_public_path__ + "img/pt-pt.9ddaa54c.png";